import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(() => localStorage.getItem("bb_token"));
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const t = localStorage.getItem("bb_token");
      if (!t) {
        setUser(null);
        setLoading(false);
        return;
      }
      const { data } = await api.get("/auth/me");
      setUser(data.user);
    } catch {
      logout();
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
    const handler = () => logout();
    window.addEventListener("bb:auth-expired", handler);
    return () => window.removeEventListener("bb:auth-expired", handler);
  }, [refresh]);

  function login(tokenStr, userObj) {
    localStorage.setItem("bb_token", tokenStr);
    setToken(tokenStr);
    setUser(userObj);
  }

  function logout() {
    localStorage.removeItem("bb_token");
    setToken(null);
    setUser(null);
  }

  return (
    <AuthCtx.Provider value={{ user, token, loading, login, logout, setUser, refresh }}>
      {children}
    </AuthCtx.Provider>
  );
}

export function useAuth() {
  return useContext(AuthCtx);
}
